export { ROUTES } from '@/app/app/routing/routes'

export const RESET_TOKEN_ERROR = {
    EXPIRED: 'token_expired',
} as const
